import React, { useState, useMemo } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useIntl } from 'react-intl';

import { IItem } from 'api/catalog/models';

import ItemAttributes from '../ItemAttributes';
import ItemAvailability from '../ItemAvailability';
import ItemNutrition from '../ItemNutrition';
import messages from '../messages';
import ItemAdditionalDetails from '../ItemAdditionalDetails';

interface IProps {
  item: IItem;
}

const DetailedItemInformation = ({ item }: IProps) => {
  const { formatMessage } = useIntl();
  const [activeTab, setActiveTab] = useState(0);

  const getA11yProps = (index: number) => ({
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  });

  const tabContent = useMemo(() => {
    switch (activeTab) {
      case 1:
        return <ItemNutrition item={item} />;
      case 2:
        return <ItemAvailability item={item} />;
      case 3:
        return <ItemAdditionalDetails item={item} />;
      default:
        return <ItemAttributes item={item} />;
    }
  }, [activeTab, item]);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={(e, tabNumber) => setActiveTab(tabNumber)}
          aria-label={formatMessage(messages.tabAriaLabel)}
        >
          <Tab
            label={formatMessage(messages.attributesTabHeader)}
            {...getA11yProps(0)}
          />
          <Tab
            label={formatMessage(messages.nutritionTabHeader)}
            {...getA11yProps(1)}
          />
          <Tab
            label={formatMessage(messages.availabilityTabHeader)}
            {...getA11yProps(2)}
          />
          <Tab
            label={formatMessage(messages.additionalDetailsTabHeader)}
            {...getA11yProps(3)}
          />
        </Tabs>
      </Box>
      <Box>{tabContent}</Box>
    </Box>
  );
};

export default DetailedItemInformation;
